import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "../i18n/fr/index";
import axios from "axios";
import ElementLocale from "element-ui/lib/locale";
import elementFr from "element-ui/lib/locale/lang/fr";
import elementEn from "element-ui/lib/locale/lang/en";

Vue.use(VueI18n);

// Element UI texts ("No data", "No matching data"...) follow the app language.
const elementLanguages = { fr: elementFr, en: elementEn };

export const i18n = new VueI18n({
  locale: "fr",
  fallbackLocale: "fr",
  messages: { fr: messages },
});

const loadedLanguages = ["fr"]; // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang;
  ElementLocale.use(elementLanguages[lang] || elementFr);
  axios.defaults.headers.common["Accept-Language"] = lang;
  document.querySelector("html").setAttribute("lang", lang);
  return lang;
}

export function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language hasn't been loaded yet
  return import(
    /* webpackChunkName: "lang-[request]" */ `../i18n/${lang}/index.js`
  ).then((messages) => {
    i18n.setLocaleMessage(lang, messages.default);
    loadedLanguages.push(lang);
    return setI18nLanguage(lang);
  });
}
